<template>
    <div class="footer">
        <div class="wrap footer_wrap">
            <div class="ftlogo"></div>
            <div class="ftcon">
                <p>声明：本网资讯仅供体育爱好者浏览、购买中国足彩参考之用。任何人不得用于非法用途,否则责任自负。本网所登载广告均为广告客户的个人意见及表达方式,和本网无任何关系。
                链接的广告不得违反国家法律规定,如有违者,本网有权随时予以删除,并保留与有关部门合作追究的权利。本网站拒绝为任何具有赌博性质的组织进行广告链接和服务。</p>
                <p class="cr">Copyright © 鸿利网 ALL Rights Reserved.</p>
            </div>
            <div class="ftcode">
                <div class="img"></div>
                <div class="name">扫一扫联系微信客服</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "footer",
        mounted(){

        },
        data(){
            return {
                
            }
        },
        methods: {

        }
    }
</script>

<style scoped>
</style>
